<template>
  <generic-modal
    :title="$t('send by mail')"
    icon="envelope"
    image="/images/icons/support_control.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="field">
          <label for>{{ $t("email") }}</label>
          <input type="text" name="email" v-model="email" />
        </div>
        <pre> {{ service_in }} </pre>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { local_api /*, error_toast*/ } from "@/utils";

export default {
  name: "SupportControlSendMailModal",
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  props: { service_in: Object },
  data() {
    return { email: "" };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/support_control/do-send-report", {
            e: vm.email,
            s: vm.service_in.uuid,
          })
            .then(() => {
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        email: ["empty", "email"],
      },
    });

    if (vm.service_in && vm.service_in.ctm_customer) {
      let setup = vm.service_in.ctm_customer.setup;
      if (setup) {
        try {
          setup = JSON.parse(setup);
          console.log(setup);
          /** TODO: Set customer email by default */
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
